import { render, staticRenderFns } from "./privilegeCoupon.vue?vue&type=template&id=6ba4e39c"
import script from "./privilegeCoupon.vue?vue&type=script&lang=js"
export * from "./privilegeCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports